export const uiInitialState = {
	isOpen: {
		isOpen: false
	}
};
